<div class="flex items-center gap-2">
  <input
    type="radio"
    [id]="radioId"
    [name]="formControlName()"
    [value]="value()"
    [checked]="isChecked"
    [disabled]="isDisabled"
    (change)="onRadioChange($event)"
    (blur)="onBlur()"
    class="w-6 h-6 border-0 accent-primary-700" />
  <label [for]="radioId" class="cursor-pointer">
    {{ label() }}
  </label>
</div>
